import React from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import animationData from '../assets/404.json';

function Error404() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white">
      {/* TACH Logo */}
      <div className="absolute left-8 top-8">
        <img src="/TachLogo.svg" alt="TACH Logo" className="h-6" />
      </div>

      {/* Main Content */}
      <div className="flex flex-col items-center">
        {/* Error message and traffic cone */}
        <div className="flex items-center gap-16">
          {/* Left side - Error message */}
          <div className="flex flex-col">
            <h1 className="mb-2 text-4xl font-bold text-gray-900">
              This page no
            </h1>
            <h1 className="mb-6 text-4xl font-bold text-gray-900">
              longer exists
            </h1>
            <p className="mb-8 text-gray-600">
              The page you were looking for could not be found.
            </p>
            <button
              onClick={() => navigate('/dashboard/home')}
              className="w-fit rounded-full bg-accent px-8 py-3 font-medium text-white transition-colors hover:bg-orange-500"
            >
              Back to home
            </button>
          </div>

          {/* Right side - Traffic cone illustration */}
          <div className="w-1/2">
            <Lottie animationData={animationData} loop={true} autoplay={true} />
          </div>
        </div>
        <div className="mb-16 text-3xl font-bold text-gray-300">ERROR 404</div>
      </div>
    </div>
  );
}

export default Error404;
